import apiClient from '../../api/http-common';

const getFtpData = () =>
  apiClient.post('/settings/ftp/edit')

const getFtpOptions = () =>
  apiClient.post('/settings/ftp/get-options-data')

const checkFtpConnection = (data) =>
  apiClient.post('/settings/ftp/check-connection', data)

const updateFtps = (data) =>
  apiClient.post('/settings/ftp/update', data)

const getFtpsLogs = (data) =>
  apiClient.post('/ftp-logs/index', data)

const getFtpsLogsOptions = () =>
  apiClient.post('/ftp-logs/get-index-data')

const downloadLogs = (data) =>
  apiClient.post('/ftp-logs/export', data)

const downloadOriginalLog = (id: string) =>
  apiClient.post(`/ftp-logs/${id}/get-file`)

const FTPService = {
  getFtpData,
  getFtpOptions,
  checkFtpConnection,
  updateFtps,
  getFtpsLogs,
  getFtpsLogsOptions,
  downloadLogs,
  downloadOriginalLog
};

export default FTPService;